<app-custom-spinner *ngIf="isLoading"></app-custom-spinner>

<ng-container *ngIf="projectInfo">

  <div class="top-info-wrapper">
    <div [ngStyle]="getBackgroundImageWithGradient(projectInfo.picture_cover)" class="top-info">
      <div class="top-bottom-info-wrapper">
        <div (click)="onBackButtonClick()"
             class="container-xl back-to-projects">
          <i class="fa-solid fa-angle-left"></i>
          <a>{{ (backCustomUrl === Constants.NAV_CONTEXT_HOME ?
            'GENERAL.back' : 'PROJECT_PAGE.back_projectpage') |translate }}</a>
        </div>
        <div class="container-xl top-bottom-info">
          <div class="impact-axis">
            <div class="impact-axis-item">
              {{"PREFERENCES_POPUP_1." + projectInfo.north_star + "_preferencespopup1" | translate | capitalize}}
            </div>
            <div *ngIf="projectInfo.north_star_2" class="impact-axis-item">
              {{"PREFERENCES_POPUP_1." + projectInfo.north_star_2 + "_preferencespopup1" | translate | capitalize}}
            </div>
            <div *ngIf="projectInfo.north_star_3" class="impact-axis-item">
              {{"PREFERENCES_POPUP_1." + projectInfo.north_star_3 + "_preferencespopup1" | translate | capitalize}}
            </div>
          </div>
          <div class="name">
            {{projectInfo.name[currentLanguage]}}
            <span *ngIf="isVoted" class="icon supported">
              <div [center]="true"
                   [left]="true"
                   [marginTop]="8"
                   [padding]="2"
                   [tooltipText]="getVotedText()"
                   [tooltipWidthMaxContent]="true"
                   [top]="false"
                   nsTooltip
                   style="height: 100%; text-shadow: none;"></div>
            </span>
            <span *ngIf="isOwnMoney(projectInfo.id)" class="icon supported own-money">
              <div [center]="true"
                   [left]="true"
                   [marginTop]="8"
                   [padding]="2"
                   [tooltipText]="getOwnMoneyText()"
                   [tooltipWidthMaxContent]="true"
                   [top]="false"
                   nsTooltip
                   style="height: 100%; text-shadow: none;"></div>
            </span>
          </div>
          <div *ngIf="projectInfo.continent === 'worldwide'; else noworldwideproject" class="location">
            {{ "PREFERENCES_POPUP_2." + projectInfo.continent + "_preferencespopup2" | translate }}
          </div>
          <ng-template #noworldwideproject>
            <div class="location">
              {{ "PREFERENCES_POPUP_2." + projectInfo.continent + "_preferencespopup2" | translate }}
              - {{"COUNTRIES." + projectInfo.country | translate}}
            </div>
          </ng-template>
          <div class="impact-axis-mobile">
            <div class="impact-axis-item">
              {{"PREFERENCES_POPUP_1." + projectInfo.north_star + "_preferencespopup1" | translate | capitalize}}
            </div>
            <div *ngIf="projectInfo.north_star_2" class="impact-axis-item">
              {{"PREFERENCES_POPUP_1." + projectInfo.north_star_2 + "_preferencespopup1" | translate | capitalize}}
            </div>
            <div *ngIf="projectInfo.north_star_3" class="impact-axis-item">
              {{"PREFERENCES_POPUP_1." + projectInfo.north_star_3 + "_preferencespopup1" | translate | capitalize}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="project-header">
    <div class="container-xl project-header-container d-md-flex">
      <div class="left-part">
        <a (click)="currentTab('projects')"
           [routerLink]="[RouterUrls.BrowseProjectsProjectDescription]"
           class="project-tab"
           routerLinkActive="active">
          {{ "PROJECT_PAGE.the_project_projectpage" | translate }}</a>
        <a (click)="currentTab('news')"
           [routerLink]="[RouterUrls.BrowseProjectsProjectArticles]"
           class="news-tab"
           routerLinkActive="active">
          {{ "PROJECT_PAGE.news_projectpage" | translate }}</a>
        <a (click)="currentTab('volunteering')"
           *ngIf="isLogged && isPledge"
           [routerLink]="[RouterUrls.BrowseProjectsProjectVolunteering]"
           class="volunteering-tab"
           routerLinkActive="active">
          {{ "PROJECT_PAGE.volunteering_projectpage" | translate }}</a>
        <span class="pill"></span>
      </div>

      <div class="right-part">
        <button [appTooltip]="projectInfo.slug" [shareType]="{type: rootShare}" class="custom-button">
          <img alt="pin" src="/assets/icons/share-dark-blue-2.svg">
          {{ "PROJECT_PAGE.share_projectpage" | translate }}</button>
        <!-- The block will be hidden if the user data is not ready or the next business logic does NOT apply -->
        <div *ngIf="isLoaded && !(!projectInfo.active || (isLogged && isPledge && !projectInfo.can_vote))"
             class="buttons-wrapper">
          <!-- CASE: NOT LOGGED -->
          <div (click)="onSignUpClick()" *ngIf="!isLogged" class="round-yellow-button">
            <span>{{ 'PROJECT_PAGE.sign_up1_projectpage' | translate }} {{ 'PROJECT_PAGE.sign_up2_projectpage' | translate }}</span>
          </div>
          <!-- CASE: LOGGED BUT NO PLEDGE -->
          <div (click)="onDonateButtonClick()" *ngIf="isLogged && !isPledge && !hasSubscription"
               class="donate-yellow-button">
            <div class="colibri-2"></div>
            <span>{{ 'PROJECT_PAGE.donate2_projectpage' | translate }}</span>
          </div>
          <!-- CASE: LOGGED & PLEDGE -->
          <div (click)="onVoteButtonClick()"
               *ngIf="isLogged && ((isPledge && projectInfo.can_vote && !isVoted) || (!isPledge && hasSubscription && !isVoted))"
               class="vote-yellow-button">
            <div class="flash"></div>
            <span>{{ 'PROJECT_PAGE.vote_projectpage' | translate }}</span>
          </div>
          <div
            *ngIf="isLogged && ((isPledge && projectInfo.can_vote && isVoted) || (!isPledge && hasSubscription && isVoted))"
            class="vote-unactive-button">
            <div class="flash"></div>
            <span>{{ 'PROJECT_PAGE.voted_projectpage' | translate }}</span>
          </div>
          <div (click)="stopSupporting()" *ngIf="isVoted"
               class="stop-supporting">{{ "PROJECT_PAGE.stop_projectpage" | translate }}</div>
          <div (click)="onDonateButtonClick()"
               *ngIf="isLogged && ((isPledge && projectInfo.can_vote) || (!isPledge && hasSubscription))"
               class="donate-button">
            <div class="colibri-1">
              <img src="/assets/icons/colibri-very-dark-grey.svg">
            </div>
            <span>{{ 'PROJECT_PAGE.donate2_projectpage' | translate }}</span>
          </div>
          <div *ngIf="isLogged && isPledge" class="votes-number">
            <img loading="lazy" src="/assets/icons/north_star/{{ projectInfo.north_star }}_selected.svg" alt="{{ projectInfo.north_star }}">
            <ng-container *ngIf="projectInfo?.votes > 1">
              {{ 'PROJECT_PAGE.supporting0_projectpage' | translate }}
              <div>
                <span>{{ projectInfo.votes }}</span>
                {{ 'PROJECT_PAGE.supporting1_projectpage' | translate }}
              </div>
            </ng-container>
            <ng-container *ngIf="projectInfo?.votes === 1">
              <div>
                <span>{{ projectInfo.votes }}</span>
                {{ 'PROJECT_PAGE.supporting2_projectpage' | translate }}
              </div>
            </ng-container>
            <ng-container *ngIf="projectInfo.votes === 0">
              {{ 'PROJECT_PAGE.supporting3_projectpage' | translate }}
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="tab !== 'volunteering'; else volBlock"
       class="container-xl router-block">
    <div class="router-outlet">
      <router-outlet></router-outlet>
    </div>
    <div *ngIf="tab !== 'volunteering'" class="side-block"
         [ngClass]="{'mt-77': isPledge && !(!projectInfo.can_vote && isLogged),'mt-53': !isLogged, 'mt-34': isLogged && !isPledge}">
        <div class="logo">
          <img [src]="projectInfo.organization_logo" alt="logo">
        </div>
        <div class="about">{{ 'PROJECT_PAGE.about_projectpage' | translate }} {{ projectInfo.organization_name }}</div>
        <div class="custom-separator"></div>
        <div *ngFor="let additional_data of projectInfo.organization_additional_data" class="additional-data">
          <div class="additional-data-name">{{ additional_data.name[currentLanguage] }}</div>
          <div [innerHTML]="additional_data.value[currentLanguage]" class="additional-data-value"></div>
        </div>
        <div *ngIf="projectInfo.organization_website"
             class="website-title">{{ 'PROJECT_PAGE.website_projectpage' | translate }}</div>
        <div *ngIf="projectInfo.organization_website" class="website-content"><a
          [href]="projectInfo.organization_website[currentLanguage]"
          target="_blank">{{ projectInfo.organization_website[currentLanguage] }}</a></div>
        <div class="mission-title">{{ 'PROJECT_PAGE.mission_projectpage' | translate }}</div>
        <div class="custom-separator"></div>
        <div class="mission-content" [innerHTML]="projectInfo.organization_description[currentLanguage]"></div>
        <div class="sdg">
          <div class="sdg-title">{{ "PROJECT_PAGE.sdg_title_projectpage" | translate }}</div>
          <div class="sdg-wrapper">
            <div *ngFor="let sdg of projectInfo.sdg" class="sdg-item">
              <div [left]="true"
                   [tooltipText]="getSDGText(sdg.name)"
                   [tooltipTitle]="getSDGTitle(sdg.name)"
                   [tooltipWidth]="300"
                   [top]="false"
                   nsTooltip>
                <img [src]="sdg.image" alt="pic" loading="lazy">
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="projectInfo.standards.length >= 1" class="standards">
          <div class="standards-title">{{ 'PROJECT_PAGE.standards3_projectpage' | translate }}</div>
          <div class="custom-separator"></div>
          <div *ngFor="let standard of projectInfo.standards" class="standard-item">
            <img [src]="standard" alt="standard-logo">
          </div>
      </div>
    </div>
  </div>
  <!-- The block will be hidden if the user data is not ready or the next business logic does NOT apply -->
  <div *ngIf="isLoaded && !(!projectInfo.active || (isLogged && isPledge && !projectInfo.can_vote))"
       class="mobile-buttons-wrapper">
    <div (click)="onSignUpClick()" *ngIf="!isLogged" class="round-yellow-button">
      <span>{{ 'PROJECT_PAGE.sign_up1_projectpage' | translate }} {{ 'PROJECT_PAGE.sign_up2_projectpage' | translate }}</span>
    </div>
    <div (click)="onVoteButtonClick()"
         *ngIf="isLogged && ((isPledge && !isVoted) || (!isPledge && hasSubscription && !isVoted))"
         class="vote-yellow-button">
      <div class="flash"></div>
      <span>{{ 'PROJECT_PAGE.vote_projectpage' | translate }}</span>
    </div>
    <div
      *ngIf="isLogged && ((isPledge && isVoted) || (!isPledge && hasSubscription && isVoted))"
      class="vote-unactive-button">
      <div class="flash"></div>
      <span>{{ 'PROJECT_PAGE.voted_projectpage' | translate }}</span>
    </div>
    <div (click)="stopSupporting()" *ngIf="isVoted"
         class="stop-supporting">{{ "PROJECT_PAGE.stop_projectpage" | translate }}</div>
    <div (click)="onDonateButtonClick()"
         *ngIf="isLogged && (isPledge  || (!isPledge && hasSubscription))"
         class="donate-button">
      <div class="colibri-1">
        <img src="/assets/icons/colibri-very-dark-grey.svg">
      </div>
      <span>{{ 'PROJECT_PAGE.donate2_projectpage' | translate }}</span>
    </div>
    <div (click)="onDonateButtonClick()" *ngIf="isLogged && !isPledge && !hasSubscription"
         class="donate-yellow-button">
      <div class="colibri-2"></div>
      <span>{{ 'PROJECT_PAGE.donate2_projectpage' | translate }}</span>
    </div>
  </div>

  <ng-template #volBlock>
    <div *ngIf="tab === 'volunteering'" class="container-xl volunteering-block">
      <div class="router-outlet">
        <router-outlet></router-outlet>
      </div>
    </div>
  </ng-template>

  <div class="may-interested-block">
    <div class="heading">{{ "PROJECT_PAGE.also_projectpage" | translate }}</div>
    <div class="projects">
      <app-project-card
        (click)="openProjectDialog(project.id)"
        *ngFor="let project of alsoLikeProjects$ | async"
        [continent]='"PREFERENCES_POPUP_2." + projectInfo.continent + "_preferencespopup2" | translate'
        [country]='"COUNTRIES." + project.country | translate'
        [id]="project.id"
        [imgUrl]="project.picture_thumbnail"
        [name]="project.name[currentLanguage]"
        [northStar2]="project.north_star_2"
        [northStar3]="project.north_star_3"
        [northStar]="project.north_star"
        [organization]="project.organization"
        [ownMoneyProjects]="ownMoneyProjects"
        [slug]="project.slug">
      </app-project-card>
    </div>
  </div>
</ng-container>
